import React from 'react';

/**
 * Themed dialog for alert and confirm flows.
 * dialog: { title, message, confirmText, cancelText, onConfirm, danger }
 * If onConfirm is omitted → alert-only (single OK button).
 */
export default function AppDialog({ dialog, onClose }) {
  if (!dialog) return null;
  const isConfirm = !!dialog.onConfirm;

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal animate-fadein" style={{ maxWidth: '400px', width: '100%', textAlign: 'center' }}>
        {dialog.danger && (
          <div style={{ fontSize: '36px', marginBottom: '8px' }}>⚠️</div>
        )}
        <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '10px', color: dialog.danger ? '#e74c3c' : undefined }}>
          {dialog.title}
        </h2>
        <p style={{ color: '#7f8c8d', fontSize: '14px', lineHeight: '1.6', marginBottom: '20px' }}>
          {dialog.message}
        </p>
        <div className="modal-footer" style={{ justifyContent: 'center' }}>
          {isConfirm && (
            <button className="btn btn-ghost" onClick={onClose}>
              {dialog.cancelText || 'Cancel'}
            </button>
          )}
          <button
            className="btn btn-primary"
            style={dialog.danger ? { background: '#e74c3c', border: 'none' } : {}}
            onClick={() => {
              if (dialog.onConfirm) dialog.onConfirm();
              onClose();
            }}>
            {dialog.confirmText || (isConfirm ? 'Confirm' : 'OK')}
          </button>
        </div>
      </div>
    </div>
  );
}
